<template>
  <div>
    <!--  Mobile version  -->
    <v-footer dark padless v-if="$vuetify.breakpoint.xs">
      <v-card class="flex" flat tile>
        <!-- <v-card-title class="social-network-panel pb-1">
          <v-spacer></v-spacer>
          <strong class="text-body-2 text-center"
            >Nađite nas na društvenim mrežama!</strong
          >
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-title class="social-network-panel my-0 pt-0 pb-2">
          <v-spacer></v-spacer>

          <v-btn v-for="icon in icons" :key="icon" class="mx-4" dark icon>
            <v-icon size="24px">
              {{ icon }}
            </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-title> -->

        <v-card-text class="py-2 white--text text-center">
          {{ new Date().getFullYear() }} — <strong>eFaktura</strong>
        </v-card-text>
      </v-card>
    </v-footer>

    <!--  Desktop version  -->
    <v-footer dark padless fixed app v-if="!$vuetify.breakpoint.xs">
      <v-card class="flex" flat tile>
        <!--<v-card-title class="social-network-panel">
          <strong class="subheading">Ostali Arhivo proizvodi</strong>

          <v-spacer></v-spacer>

          <v-btn v-for="icon in icons" :key="icon" class="mx-4" dark icon>
            <v-icon size="24px">
              {{ icon }}
            </v-icon>
          </v-btn>
        </v-card-title>-->

        <v-card-text class="py-1 white--text text-center">
          <table width="100%">
          <tr>
            <td width="55%"><p class="text-right">{{ new Date().getFullYear() }} — <strong>eFaktura</strong></p></td>
            <td width="45%"><p class="text-right"><Language /></p></td>
          </tr>
          </table>
          
        </v-card-text>        
      </v-card>
    </v-footer>
  </div>
</template>

<script>
import Language from "../components/Language.vue"

export default {
  name: "Footer",
  components: {
            Language
        },
  data() {
    return {
      icons: [],//"mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"
    };
  },
  methods: {},
};
</script>

<style scoped>
.social-network-panel {
  background-color: #2b5d66;
}
</style>